"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _streamChatReact = require("stream-chat-react");
var _Search = _interopRequireDefault(require("./Search/Search"));
var _ManageMembers = _interopRequireDefault(require("./ManageMembers/ManageMembers"));
var _components = require("../../../components");
var _utils = require("../utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var ChannelHeader = function ChannelHeader(_ref) {
  var propChannel = _ref.channel,
    children = _ref.children;
  var _useCustomChatContext = (0, _utils.useCustomChatContext)(),
    publicChatsBan = _useCustomChatContext.publicChatsBan;
  var bannedInPublicChannels = publicChatsBan.banned;
  var _useContext = (0, _react.useContext)(_streamChatReact.ChatContext),
    contextChannel = _useContext.channel,
    client = _useContext.client;
  var channel = contextChannel || propChannel;
  var isAdmin = client.user.role === 'admin';
  var isModerator = (0, _react.useMemo)(function () {
    var member = channel.state.members[client.user.id];
    return member && !!member.is_moderator;
  }, [channel]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__header"
  }, channel && /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__header-info"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__header-info--title"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "channel-name-block"
  }, channel.data.name)), /*#__PURE__*/_react.default.createElement("div", {
    className: "str-chat__header-info--users"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex items-center str-chat__header-channel-name text-grey-75 pb-[2px]"
  }, /*#__PURE__*/_react.default.createElement(_components.Icon, {
    type: "hash",
    size: 16,
    viewBoxSize: 16
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "block ml-[4px]"
  }, channel.data.name)), channel.state.watcher_count, " members online", (isAdmin || isModerator) && /*#__PURE__*/_react.default.createElement(_ManageMembers.default, {
    channel: channel,
    client: client
  }), children)), !bannedInPublicChannels && /*#__PURE__*/_react.default.createElement(_Search.default, {
    chatClient: client,
    channel: channel
  }));
};
var _default = ChannelHeader;
exports.default = _default;